import {loggingApi} from "../../apis/logging/loggingApi";
import {ApiClientError, ApiServerError} from "../../apis/errors";

export const logError = async <T extends Error>(path: string, message: string, error: T | null = null) => {
  try {
    let messageJson = {};

    if (error instanceof ApiClientError) {
      messageJson = {
        message,
        error: {
          response: {
            message: error.message,
            code: error.code,
            status: error.status,
            errors: error.errors,
          }
        }
      };
    } else if (error instanceof ApiServerError) {
      messageJson = {
        message,
        error: {
          response: {
            message: error.message,
            code: error.code,
            status: error.status,
          }
        }
      };
    } else if (error instanceof Error) {
      messageJson = {
        message,
        stack: error.stack,
      };
    } else {
      messageJson = {
        message,
      }
    }

    loggingApi.log({
      severity: 'ERROR',
      path,
      userAgent: window.navigator.userAgent,
      message: JSON.stringify(messageJson),
    }, {}).catch((e: object) => {
      console.error(e);
    });
  } catch(err) {
    console.error(err);
  }
}